import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { CalendarOptions, DateSelectArg, EventApi, EventDropArg, FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarApi, DatesSetArg, EventClickArg, EventContentArg, SlotLabelContentArg } from '@fullcalendar/common';
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { EventResizeDoneArg } from "@fullcalendar/interaction";
import { ResourceLabelContentArg, ResourceLabelMountArg } from '@fullcalendar/resource-common';
import { ConfiguracaoAgendaEmpresaService } from 'src/app/admihair/service/configuracao-agenda-empresa.service';
import { ConfiguracaoAgendaEmpresa } from 'src/app/admihair/api/dto/configuracao-agenda-empresa';
import { ConfiguracaoAgendaProfissionalService } from 'src/app/admihair/service/configuracao-agenda-profissional.service';
import { ConfiguracaoAgendaProfissional } from 'src/app/admihair/api/dto/configuracao-agenda-profissional';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';

import { calcularHoraFimAgendamento, isEventoCompacto } from './utils/agenda-utils';
import { CalendarioAgendaService } from 'src/app/admihair/service/calendario-agenda.service';
import { AgendaEmpresaService } from 'src/app/admihair/service/agenda-empresa.service';
import { EventoCalendarioAgenda } from 'src/app/admihair/api/dto/evento-calendario-agenda';
import { BloqueioAgendaService } from 'src/app/admihair/service/bloqueio-agenda.service';
import { AgendaEmpresaResponse } from 'src/app/admihair/api/dto/agenda-empresa-response';
import { AgendaEmpresaRequest } from 'src/app/admihair/api/dto/agenda-empresa-request';
import { AgendaEventoRenderService } from './services/agenda-evento-render.service';
import { AgendaEventoMapperService } from './services/agenda-evento-mapper.service';
import { AgendaRecursosService } from './services/agenda-recursos.service';
import { Observable, of, switchMap, tap } from 'rxjs';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { Dialog } from 'primeng/dialog';
import { BloqueioAgendaRequest, BloqueioAgendaUpdateRequest } from 'src/app/admihair/api/dto/bloqueio-agenda-request';
import { BloqueioAgendaResponse } from 'src/app/admihair/api/dto/bloqueio-agenda-response';
import { DateUtil } from 'src/app/admihair/util/date-util';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { OverlayPanel } from 'primeng/overlaypanel';

import tippy, { Instance } from 'tippy.js';

@Component({
  selector: 'app-agenda-empresa',
  templateUrl: './agenda-empresa.component.html',
  styleUrls: ['./agenda-empresa.component.scss']
})
export class AgendaEmpresaComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('op') overlayPanel!: OverlayPanel;
  hoveredEvent: EventApi | null = null;
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  exibirFullCalendar: boolean = true;
  calendarOptions: CalendarOptions = { initialView: 'dayGridMonth' };
  dataSelecionadaCalendario?: Date;

  eventosAgenda: EventoCalendarioAgenda[] = [];
  configuracoesEmpresa: ConfiguracaoAgendaEmpresa[] = [];
  configuracoesProfissionais: ConfiguracaoAgendaProfissional[] = [];

  profissionais: Profissional[] = [];

  novoBloqueioAgenda: BloqueioAgendaRequest = {};
  agendamentoPreferencial: boolean = false;
  idAgendamentoClicado?: number;

  profissionaisHabilitadosBloqueio: SelectItem[] = [];
  dataBloqueio?: Date;

  @ViewChild('inserirEventoAgenda') dialog!: Dialog;
  exibirInserirEventoAgenda: boolean = false;
  tipoEventoAgenda: 'AGENDAMENTO' | 'BLOQUEIO' = 'AGENDAMENTO';
  profissionalSelecionado?: Profissional;
  clienteSelecionado?: Cliente;

  agendamentoSelecionado?: AgendaEmpresaResponse;

  exibirDetalheAgendamento: boolean = false;
  exibirDetalheBloqueio: boolean = false;
  exibirInserirBloqueio: boolean = false;
  exibirSelecaoCliente: boolean = false;
  exibirCadastroCliente: boolean = false;
  exibirSelecaoServico: boolean = false;
  exibirDetalheAgendaProfissional: boolean = false;
  exibirDetalheAgendaCliente: boolean = false;
  bloqueioIdSelecionado?: number;

  loadingDetalheAgendamento = false;
  modoEdicaoDescricao = false;
  descricaoOriginal = '';

  novoAgendamento: AgendaEmpresaRequest = {
    descricao: '',
    encaixe: false,
    preferencial: false,
    recorrente: false,
    recorrencia: undefined,
    servicos: []
  };
  descricaoItemExclusivoSelecionado?: string;
  servicosNovoAgendamento: ItemServico[] = [];

  datasRecorrenciaAgendamento: Date[] | undefined;
  minDateAgendamento: Date = new Date();
  maxDateAgendamento: Date = this.adicionarDias(new Date(), 365);

  datasRecorrenciaBloqueio: Date[] | undefined;
  minDateBloqueio: Date = new Date();
  maxDateBloqueio: Date = this.adicionarDias(new Date(), 365);

  listaFiltroGrupos: any[] = [];
  listaFiltroGruposSelecionados: number[] = [];


  totalItensPagina: SelectItem[] = [
    { value: 1, label: '1 Coluna' },
    { value: 2, label: '2 Colunas' },
    { value: 3, label: '3 Colunas' },
    { value: 4, label: '4 Colunas' },
    { value: 5, label: '5 Colunas' },
    { value: 6, label: '6 Colunas' },
    { value: 7, label: '7 Colunas' },
    { value: 8, label: '8 Colunas' }
  ];

  tamanhoPagina: number = 8;
  paginaAtual: number = 0;
  paginaAtualExibicao: number = 1;
  totalPaginas: number = 0;
  totalElementos: number = 0;
  itensPagina: string[] = [];


  constructor(private configuracaoAgendaEmpresaService: ConfiguracaoAgendaEmpresaService,
    private configuracaoAgendaProfissionalService: ConfiguracaoAgendaProfissionalService,
    private agendaEmpresaService: AgendaEmpresaService,
    private calendarioAgendaService: CalendarioAgendaService,
    private bloqueioAgendaService: BloqueioAgendaService,
    private grupoService: GrupoService,
    private confirmationService: ConfirmationService,
    private eventoMapper: AgendaEventoMapperService,
    private renderService: AgendaEventoRenderService,
    private recursosService: AgendaRecursosService,
    private layoutService: LayoutService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  private adicionarDias(data: Date, dias: number): Date {
    const resultado = new Date(data);
    resultado.setDate(resultado.getDate() + dias);
    return resultado;
  }


  alterarTamanhoPagina() {
    this.paginaAtual = 0;
    this.carregarPagina();
  }


  carregarPagina(): void {

    const inicio = this.paginaAtual * this.tamanhoPagina;
    const fim = inicio + this.tamanhoPagina;

    if (this.dataSelecionadaCalendario) {

      this.calendarOptions.resources = this.recursosService
        .buildResources(this.dataSelecionadaCalendario, this.configuracoesProfissionais.slice(inicio, fim))
    } else {
      this.calendarOptions.resources = [];
    }

    this.atualizarPaginacao();

  }

  atualizarPaginacao(): void {
    this.totalPaginas = Math.ceil(
      this.totalElementos / this.tamanhoPagina
    );

    this.paginaAtualExibicao = this.paginaAtual + 1;
  }

  proximaPagina(): void {
    if (!this.estaNaUltimaPagina()) {
      this.paginaAtual++;
      this.carregarPagina();
    }
  }

  paginaAnterior(): void {
    if (!this.estaNaPrimeiraPagina()) {
      this.paginaAtual--;
      this.carregarPagina();
    }
  }

  estaNaPrimeiraPagina(): boolean {
    return this.paginaAtual === 0;
  }

  estaNaUltimaPagina(): boolean {
    return (this.paginaAtual + 1) * this.tamanhoPagina >= this.totalElementos;
  }




  ngOnInit(): void {
    //this.layoutService.onMenuToggle();
    this.permissaoListar = true;
    this.dataSelecionadaCalendario = new Date();
    this.totalElementos = this.configuracoesProfissionais.length;
    this.inicializarCalendario();
    this.carregarFiltros();
  }

  carregarFiltros() {
    this.grupoService.listarHabilitadosProfissionais().subscribe({
      next: (data: any[]) => {
        this.listaFiltroGrupos = data;
        this.carregarConfiguracoesDaAgenda();
      },
      error: (err: any) => {

      }
    })
  }

  // FULLCALENDAR
  inicializarCalendario() {
    this.calendarOptions = {
      locale: 'pt-br',
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      plugins: [dayGridPlugin, resourceTimeGridPlugin, interactionPlugin],
      initialView: 'resourceTimeGridDay',
      resources: [],
      resourceOrder: 'title',
      events: [],

      editable: true,
      selectable: true,
      allDaySlot: false,
      eventOverlap: true,
      slotEventOverlap: true,

      slotMinTime: '08:00',
      slotMaxTime: '17:00',
      slotDuration: '00:15',
      slotLabelInterval: '01:00',

      height: 'auto',

      headerToolbar: { left: '', right: '' },

      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        omitZeroMinute: true,
        meridiem: false,
        hour12: false,
      },

      views: {
        resourceTimeGridDay: {
          titleFormat: {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          }
        }
      },

      slotLabelContent: (args) => this.renderSlotLabel(args),
      resourceLabelContent: (args) => this.renderResourceLabel(args),
      eventContent: (info) => this.renderEventContent(info),

      resourceLabelDidMount: (info) => this.onResourceLabelClick(info),
      select: (info) => this.onDateSelect(info),
      eventClick: (info) => this.onEventClick(info),
      datesSet: (arg) => this.onDatesSet(arg),
      eventDrop: (arg) => this.onEventDrop(arg),
      eventResize: (arg) => this.onEventResize(arg),
      eventAllow: (dropInfo, draggedEvent) => {
        const entityType = draggedEvent?.extendedProps['entityType'];
        if (entityType === 'BLOQUEIO') {
          const resourceIdNew = dropInfo.resource?.id;
          const resourceIdOld = draggedEvent?.extendedProps['profissionalId'];

          return resourceIdNew == resourceIdOld;
        }
        return true;
      },

      eventDidMount: (info) => {
        this.createEventTooltip(info.el, info.event);
      },
      eventWillUnmount: (info) => {

        const tooltip = (info.el as HTMLElement & {
          _tippy?: Instance;
        })._tippy;

        tooltip?.destroy();
      }
    };
  }

  private createEventTooltip(
    element: HTMLElement,
    event: EventApi
  ): void {

    tippy(element, {
      content: this.buildTooltipContent(event),
      allowHTML: true,
      interactive: true,
      placement: 'top',
      theme: 'agenda',
      animation: 'shift-away',
      appendTo: document.body,
      maxWidth: 320,
      delay: [200, 100]
    });
  }

  private buildTooltipContent2(event: EventApi): string {

    const tipo = event.extendedProps['tipo'];

    const profissional = event.extendedProps['profissional'];
    const cliente = event.extendedProps['cliente'];
    const itens = event.extendedProps['itens'];
    const descricao = event.extendedProps['descricao'];
    const horario = event.extendedProps['horario'];

    if (tipo === 'AGENDAMENTO') {

      return `
      <div class="agenda-tooltip">

        <div class="agenda-tooltip-header">
          <div class="agenda-status-dot"></div>
          <span class="agenda-tooltip-title">
            Agendamento
          </span>
        </div>

        <div class="agenda-tooltip-body">

          <div class="agenda-row">
            <span class="agenda-label">Cliente</span>
            <span class="agenda-value">${cliente}</span>
          </div>

          <div class="agenda-row">
            <span class="agenda-label">Profissional</span>
            <span class="agenda-value">${profissional}</span>
          </div>

          <div class="agenda-row">
            <span class="agenda-label">Serviços</span>
            <span class="agenda-value">${itens}</span>
          </div>

          <div class="agenda-row">
            <span class="agenda-label">Horário</span>
            <span class="agenda-value">${horario}</span>
          </div>

          ${descricao
          ? `
                <div class="agenda-description">
                  ${descricao}
                </div>
              `
          : ''
        }

        </div>

      </div>
    `;
    }

    return `
    <div class="agenda-tooltip">

      <div class="agenda-tooltip-header bloqueio">
        <div class="agenda-status-dot bloqueio"></div>
        <span class="agenda-tooltip-title">
          Bloqueio de Agenda
        </span>
      </div>

      <div class="agenda-tooltip-body">

        <div class="agenda-description">
          ${descricao}
        </div>

      </div>

    </div>
  `;
  }


  private truncate(text: string, max: number): string {
    if (!text) return '';
    return text.length > max ? text.slice(0, max) + '...' : text;
  }

  private formatItensComIcone(itensStr: string): string {
  if (!itensStr) return '';

  return itensStr
    .split('|')
    .map(item => item.trim())
    .filter(Boolean)
    .map(item => `
      <div >
        <i class="pi pi-slack text-700"></i>
        <span>${item}</span>
      </div>
    `)
    .join('');
}

  private buildTooltipContent(event: EventApi): string {

    const { tipo, descricao = '', itens = '' } = event.extendedProps ?? {};

    const mensagem = this.truncate(descricao, 125);

    const itensHtml = this.formatItensComIcone(itens);

    if (tipo === 'AGENDAMENTO') {
      return `
      <div>
        <div class="flex justify-content-end">
          <span class="tipo-agenda">NORMAL</span>
        </div>
        <div class="mb-1">
          <span>${itensHtml}</span>
        </div>
        <div class="divider-hr"></div>
        <div>
          <i class="pi pi-comment text-700 mr-1"></i>
          <span>${mensagem}</span>
        </div>
      </div>
    `;
    }

    return `
    <div>
    <div class="mb-1">
          <i class="pi pi-ban text-700 mr-1"></i>
          <span>BLOQUEIO</span>
        </div>
        <div class="divider-hr"></div>
        <div>
          <i class="pi pi-comment text-700 mr-1"></i>
          <span>${event.extendedProps['descricao']}</span>
        </div>
      </div>
      `;

  }

  private onEventDrop(arg: EventDropArg) {
    const evento = arg.event;
    const entityType = this.getEventEntityType(evento);
    const eventoId = this.getEventEntityId(evento);

    if (entityType === 'AGENDAMENTO') {
      const newResource = arg.newResource;
      const oldResource = arg.oldResource;

      const msg = newResource != oldResource
        ? 'Confirmar alteração de profissional?'
        : 'Confirmar ajuste de horário do Agendamento?';

      this.confirmarEPersistirAlteracaoEvento(
        msg,
        () => this.agendaEmpresaService.reagendar(eventoId, this.montarDtoAtualizarAgendamento(evento)),
        () => arg.revert(),
        true
      );
    } else {
      this.confirmarEPersistirAlteracaoEvento(
        'Confirmar ajuste de horário do Bloqueio?',
        () => this.bloqueioAgendaService.reagendar(eventoId, this.montarDtoAtualizarBloqueio(evento)),
        () => arg.revert(),
        true
      );
    }
  }

  private onEventResize(arg: EventResizeDoneArg) {
    const evento = arg.event;
    const eventoId = this.getEventEntityId(evento);
    const eventType = this.getEventEntityType(evento);

    if (eventType === 'AGENDAMENTO') {
      this.confirmarEPersistirAlteracaoEvento(
        'Confirmar ajuste de horário do agendamento?',
        () => this.agendaEmpresaService.reagendar(eventoId, this.montarDtoAtualizarAgendamento(evento)),
        () => arg.revert(),
        false
      );
    } else {
      this.confirmarEPersistirAlteracaoEvento(
        'Confirmar ajuste de horário do bloqueio?',
        () => this.bloqueioAgendaService.reagendar(eventoId, this.montarDtoAtualizarBloqueio(evento)),
        () => arg.revert(),
        true
      );
    }
  }

  private confirmarEPersistirAlteracaoEvento(
    message: string,
    acaoPersistencia: () => Observable<unknown>,
    onRevert: () => void,
    recarregarAgenda: boolean
  ) {
    this.confirmationService.confirm({
      message,
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        acaoPersistencia().subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            if (recarregarAgenda) {
              this.carregarConfiguracoesDaAgenda();
            }
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
            onRevert();
          }
        });
      },
      reject: () => onRevert()
    });
  }

  private renderSlotLabel(args: SlotLabelContentArg): string {
    return `${args.text}:00h`;
  }

  private renderResourceLabel(args: ResourceLabelContentArg): { html: string } {
    const id = Number.parseInt(args.resource.id);
    const quantidadeEventos = this.renderService
      .obterQuantidadeEventosDoColaborador(id, this.eventosAgenda);

    return this.renderService.renderizarLabelRecursos(args.resource.title, quantidadeEventos);

  }

  private renderEventContent(info: EventContentArg): { html: string } {
    const event = info.event;
    const status = info.event.extendedProps['status'];
    const title = info.event.title;
    const time = info.timeText;
    const tipo = info.event.extendedProps['entityType'];
    const icone = tipo === 'AGENDAMENTO' ? 'user' : 'ban'

    const html = isEventoCompacto(event)
      ? this.renderService.renderizarEventoCompacto(time, title, icone)
      : this.renderService.renderizarEventoCompleto(time, title, icone, tipo, status);

    return { html };
  }

  private onResourceLabelClick(info: ResourceLabelMountArg): void {
    const id = Number(info.resource.id);
    const title = info.resource.title;

    info.el.addEventListener('click', () => {
      this.abrirDialogProfissionalDetalheAgenda(id, title);
    });
  }

  private onDateSelect(info: DateSelectArg): void {
    const dataSelecionada = new Date(info.start);
    const agora = new Date();

    dataSelecionada.setMinutes(dataSelecionada.getMinutes() + 15);

    if (dataSelecionada < agora) {
      return;
    }

    this.profissionalSelecionado = {
      id: Number(info.resource?.id),
      nomeProfissional: info.resource?.title
    }
    const horaInicio = info.startStr.substring(11, 19);

    this.novoBloqueioAgenda = {
      horaInicio: horaInicio,
      recorrente: false,
      recorrencia: undefined
    }
    this.novoAgendamento = {
      horaInicio: horaInicio,
      horaFim: '',
      descricao: '',
      encaixe: false,
      preferencial: false,
      recorrente: false,
      recorrencia: undefined,
      servicos: []
    }

    this.abrirDialogNovoEvento();
  }

  private onEventClick(info: EventClickArg): void {
    const event = info.event;

    const entityType = this.getEventEntityType(event);
    const entityId = this.getEventEntityId(event);

    if (entityType === 'AGENDAMENTO') {
      this.abrirDialogDetalheAgendamento(entityId);
      return;
    }
    this.abrirDetalheBloqueio(entityId);
  }

  private onDatesSet(arg: DatesSetArg): void {
    this.dataSelecionadaCalendario = new Date(arg.start);
  }

  private getEventEntityType(event: EventApi): 'AGENDAMENTO' | 'BLOQUEIO' {
    return event.extendedProps['entityType'] as 'AGENDAMENTO' | 'BLOQUEIO';
  }

  private getEventEntityId(event: EventApi): number {
    return Number(event.extendedProps['entityId']);
  }

  // CARREGAMENTO DE DADOS DA AGENDA
  carregarConfiguracoesDaAgenda() {
    const empresaId = this.getEmpresa().id;
    this.configuracaoAgendaEmpresaService.listarPorEmpresaId(empresaId)
      .pipe(
        tap((configsEmpresa: ConfiguracaoAgendaEmpresa[]) => {
          this.configuracoesEmpresa = configsEmpresa
        }),
        switchMap((configsEmpresa) => {
          if (configsEmpresa.length > 0) {
            return this.configuracaoAgendaProfissionalService.listarPorEmpresaIdFiltro(
              this.getDiaSemanaSelecionado(), this.listaFiltroGruposSelecionados);
          }
          return of([]);
        })
      )
      .subscribe({
        next: (configsProfissionais: ConfiguracaoAgendaProfissional[]) => {
          this.configuracoesProfissionais = configsProfissionais;
          this.totalElementos = this.configuracoesProfissionais.length;
          this.finalizarConfiguracoes();
        },
        error: (err: any) => this.exibirMensagemErro(err)
      })
  }

  private finalizarConfiguracoes() {
    this.atualizarResources();
    this.configurarQuadroAgenda();

    if (this.configuracoesProfissionais.length > 0) {
      this.profissionais = this.recursosService.processarListaProfissionais(this.configuracoesProfissionais);
    }
    this.profissionaisHabilitadosBloqueio = this.recursosService
      .buildSelectProfissionaisBloqueio(this.configuracoesProfissionais);
  }

  atualizarResources() {

    this.carregarPagina();
  }

  configurarQuadroAgenda() {

    if (!this.dataSelecionadaCalendario) {
      this.exibirErroSistema();
      return;
    }

    const diaSemana = this.getDiaSemanaSelecionado();

    if (!this.recursosService.existeConfiguracaoParaDia(diaSemana, this.configuracoesEmpresa)) {
      this.exibirMensagemAviso('Agenda não habilitada para esta data');
      return;
    }

    if (!this.recursosService.existeProfissionalDisponivel(diaSemana, this.configuracoesProfissionais)) {
      this.exibirMensagemAviso('Nenhum profissional habilitado para esta data');
      return;
    }

    this.aplicarHorarioEmpresa(diaSemana);
    this.listarAgendaEEventos();
  }

  listarAgendaEEventos() {
    if (!this.dataSelecionadaCalendario) return;

    const diaSemana = this.getDiaSemanaSelecionado();

    const api: CalendarApi = this.calendarComponent.getApi();

    const idProfissionais = api.getResources().map(r => +r.id);

    this.calendarioAgendaService.listarPorDataRegitro(this.dataSelecionadaCalendario, idProfissionais).subscribe({
      next: (data: EventoCalendarioAgenda[]) => {
        this.eventosAgenda = data;
        this.calendarOptions.events = this.eventoMapper.mapearEventos(
          data,
          diaSemana,
          this.configuracoesProfissionais,
          this.calendarOptions.slotMinTime as string,
          this.calendarOptions.slotMaxTime as string
        );
      },
      error: (err: any) => {
        this.calendarOptions.events = [];
        this.exibirMensagemErro(err);
      }
    })
  }

  private getDiaSemanaSelecionado(): number {
    return this.dataSelecionadaCalendario!.getDay() + 1;
  }

  aplicarHorarioEmpresa(diaSemana: number) {
    const configuracao = this.configuracoesEmpresa
      .find(conf => conf.diaSemanaId === diaSemana);

    if (!configuracao) return;

    this.calendarOptions.slotMinTime = configuracao.horaInicio;
    this.calendarOptions.slotMaxTime = configuracao.horaFim;
  }

  exibirMensagemAviso(aviso: string) {
    this.messages = [{
      severity: 'warn', summary: aviso,
      detail: ''
    }]
    this.exibirFullCalendar = false;
  }

  private exibirErroSistema() {
    this.messages = [{
      severity: 'error', summary: 'Houve um erro não identificado no sistema',
      detail: ''
    }];
    this.exibirFullCalendar = false;
  }

  // NAVEGACAO DO CALENDARIO
  selecionarDataPeloCalendario(date: Date): void {
    if (!date || !this.calendarComponent) return;

    const api = this.getCalendarApi();
    const dataNormalizada = new Date(date);
    dataNormalizada.setHours(12, 0, 0, 0);

    api.gotoDate(dataNormalizada);
    this.carregarConfiguracoesDaAgenda();
  }

  diaAnterior() {
    this.navegarCalendario('prev');
  }

  avancarDiaCalendario() {
    this.navegarCalendario('next');
  }

  voltarDiaCalendario() {
    this.navegarCalendario('prev');
  }

  diaAtualCalendario() {
    this.navegarCalendario('today');
  }

  // ABERTURA E CONTROLE DE DIALOGS

  abrirDialogDetalheAgendaCliente() {
    this.exibirDetalheAgendaCliente = true;
  }

  abrirDialogInserirBloqueio() {
    this.dataBloqueio = this.getCalendarApi().getDate();
    this.exibirInserirBloqueio = true;
  }

  verificarSalvarBloqueio(salvo: boolean) {
    if (salvo) {
      this.exibirMensagemSucesso();
      this.carregarConfiguracoesDaAgenda();
    }
  }

  verificarExclusaoBloqueio(excluido: boolean) {
    if (excluido) {
      this.exibirMensagemSucesso();
      this.carregarConfiguracoesDaAgenda();
    }
  }

  abrirDialogDetalheAgendamento(agendamentoId: number) {
    this.agendamentoSelecionado = undefined;
    this.modoEdicaoDescricao = false;
    this.messagesDialog = [];
    this.idAgendamentoClicado = agendamentoId;
    this.exibirDetalheAgendamento = true;
    this.carregarAgendamento();
  }

  carregarAgendamento() {
    if (!this.idAgendamentoClicado) {
      return;
    }
    this.loadingDetalheAgendamento = true;
    this.agendaEmpresaService.buscarPorId(this.idAgendamentoClicado).subscribe({
      next: (data: AgendaEmpresaResponse) => {
        this.agendamentoSelecionado = data;
        this.loadingDetalheAgendamento = false;
      },
      error: (err: any) => {
        this.loadingDetalheAgendamento = false;
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  excluirServicoAgendamento(itemId: number) {

    if (this.agendamentoSelecionado?.items && this.agendamentoSelecionado.items.length > 1) {
      this.excluirItemServico(itemId);
    } else {
      this.excluirAgendamento();
    }
  }

  excluirAgendamento() {
    this.confirmationService.confirm({
      message: 'Ao remover o último serviço o agendamento será excluído. Prosseguir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.agendaEmpresaService.excluir(this.agendamentoSelecionado?.id).subscribe({
          next: () => {
            this.loadingDetalheAgendamento = false;
            this.exibirDetalheAgendamento = false;
            this.exibirMensagemSucesso();
            this.carregarConfiguracoesDaAgenda();
          },
          error: (err: any) => {
            this.exibirMensagemErroDialog(err);
          }
        })
      }
    });
  }

  excluirItemServico(itemId: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.agendaEmpresaService.excluirItemAgendamento(this.agendamentoSelecionado?.id, itemId).subscribe({
          next: () => {
            this.exibirMensagemSucessoDialog();
            this.carregarAgendamento();
            this.carregarConfiguracoesDaAgenda();
          },
          error: (err: any) => {
            this.exibirMensagemErroDialog(err);
          }
        })
      }
    });
  }

  adicionarServicoAgendamento(item: ItemServico) {
    this.agendaEmpresaService.adicionarItem(this.agendamentoSelecionado?.id, item.id).subscribe({
      next: () => {
        this.exibirMensagemSucessoDialog();
        this.carregarAgendamento();
        this.carregarConfiguracoesDaAgenda();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  confirmarAgendamento() {
    this.agendaEmpresaService.confirmar(this.agendamentoSelecionado?.id).subscribe({
      next: () => {
        this.exibirMensagemSucessoDialog();
        this.carregarAgendamento();
        this.carregarConfiguracoesDaAgenda();
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  cancelarAgendamento() {
    this.confirmationService.confirm({
      message: 'Cancelar agendamento?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.agendaEmpresaService.cancelar(this.agendamentoSelecionado?.id!).subscribe({
          next: () => {
            this.exibirMensagemSucessoDialog();
            this.carregarAgendamento();
            this.carregarConfiguracoesDaAgenda();
          },
          error: (err: any) => {
            this.exibirMensagemErroDialog(err);
          }
        })
      }
    });

  }

  criarComandaAgendamento() {
    this.agendaEmpresaService.criarComandaAgendamento(
      this.agendamentoSelecionado?.clienteId,
      this.agendamentoSelecionado?.dataAgendamento
    ).subscribe({
      next: () => {
        this.carregarAgendamento();
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  abrirComanda() {
    const url = `${window.location.origin}/#/janela-empresa/comanda/${this.agendamentoSelecionado?.comandaId}`;
    const newWindow = window.open(url, '_blank', 'width=800,height=600,menubar=no,toolbar=no,location=no,status=no');
    if (newWindow) {
      newWindow.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          newWindow.close();
        }
      });
    }
  }

  abrirDialogNovoEvento() {
    this.messages = [];
    this.messagesDialog = [];
    this.tipoEventoAgenda = 'AGENDAMENTO'
    this.clienteSelecionado = undefined;
    this.servicosNovoAgendamento = [];
    this.datasRecorrenciaAgendamento = undefined;
    this.datasRecorrenciaBloqueio = undefined;

    this.agendamentoPreferencial = false;
    this.exibirInserirEventoAgenda = true;
  }


  salvarEvento() {
    if (this.tipoEventoAgenda === 'AGENDAMENTO') {
      this.salvarAgendamento();
      return;
    }
    this.salvarBloqueio();
  }

  removerDataRecorrencia(dataParaRemover: Date) {
    if (!this.datasRecorrenciaAgendamento?.length) {
      return;
    }

    const dataRemocao = new Date(dataParaRemover);
    dataRemocao.setHours(0, 0, 0, 0);

    this.datasRecorrenciaAgendamento = this.datasRecorrenciaAgendamento.filter((dataSelecionada) => {
      const dataAtual = new Date(dataSelecionada);
      dataAtual.setHours(0, 0, 0, 0);
      return dataAtual.getTime() !== dataRemocao.getTime();
    });

    if (!this.datasRecorrenciaAgendamento.length) {
      this.datasRecorrenciaAgendamento = undefined;
    }
  }

  removerDataRecorrenciaBloqueio(dataParaRemover: Date) {
    if (!this.datasRecorrenciaBloqueio?.length) {
      return;
    }

    const dataRemocao = new Date(dataParaRemover);
    dataRemocao.setHours(0, 0, 0, 0);

    this.datasRecorrenciaBloqueio = this.datasRecorrenciaBloqueio.filter((dataSelecionada) => {
      const dataAtual = new Date(dataSelecionada);
      dataAtual.setHours(0, 0, 0, 0);
      return dataAtual.getTime() !== dataRemocao.getTime();
    });

    if (!this.datasRecorrenciaBloqueio.length) {
      this.datasRecorrenciaBloqueio = undefined;
    }
  }

  salvarAgendamento() {

    if (!this.novoAgendamento) {
      return;
    }
    this.novoAgendamento.clienteId = this.clienteSelecionado?.id!;
    this.novoAgendamento.profissionalId = this.profissionalSelecionado?.id;
    this.novoAgendamento.dataAgendamento = this.dataSelecionadaCalendario;
    if (this.novoAgendamento.recorrente) {
      this.novoAgendamento.recorrencia = this.datasRecorrenciaAgendamento;
    }
    this.novoAgendamento.servicos = this.servicosNovoAgendamento.map(item => ({ id: item.id! }));
    this.novoAgendamento.encaixe = false;

    if (this.verificarConflitoAntesDeSalvar()) {
      this.confirmarSalvarComoEncaixe();
      return;
    }

    this.executarSalvarAgendamento();
  }

  confirmarSalvarComoEncaixe() {
    this.confirmationService.confirm({
      message: 'Conflito de horário identificado. Deseja salvar este agendamento como encaixe?',
      header: 'Conflito de Horário',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.novoAgendamento.encaixe = true;
        this.executarSalvarAgendamento();
      }
    });
  }

  executarSalvarAgendamento() {
    this.agendaEmpresaService.salvarAgendamento(this.novoAgendamento).subscribe({
      next: (data: AgendaEmpresaResponse) => {
        this.exibirInserirEventoAgenda = false;
        this.exibirMensagemSucesso();
        this.carregarConfiguracoesDaAgenda();
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);
        this.rolarTelaDialog();
      }
    });
  }

  salvarBloqueio() {
    this.novoBloqueioAgenda.profissionalId = this.profissionalSelecionado?.id
    this.novoBloqueioAgenda.modalidade = 'PARCIAL_PROFISSIONAL';
    this.novoBloqueioAgenda.dataBloqueio = this.dataSelecionadaCalendario;
    if (this.novoBloqueioAgenda.recorrente) {
      this.novoBloqueioAgenda.recorrencia = this.datasRecorrenciaBloqueio;
    }
    this.bloqueioAgendaService.salvarBloqueioParcial(this.novoBloqueioAgenda).subscribe({
      next: (data: BloqueioAgendaResponse) => {
        this.exibirInserirEventoAgenda = false;
        this.exibirMensagemSucesso();
        this.carregarConfiguracoesDaAgenda();
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);

      }
    });
  }

  removerServicoAgendamento(index: number) {
    if (!this.novoAgendamento) {
      return;
    }
    this.servicosNovoAgendamento.splice(index, 1);
    this.atualizarHoraFimNovoAgendamento();
  }


  selecionarCliente(cliente: Cliente): void {
    this.clienteSelecionado = cliente;
    this.exibirSelecaoCliente = false;
  }


  selecionarServico(item: ItemServico) {
    if (item.agenda === 'EXCLUSIVO') {
      this.novoAgendamento.itemExclusivoId = item.id;
      this.descricaoItemExclusivoSelecionado = item.descricao;
      return;
    }


    if (this.exibirDetalheAgendamento) {
      this.adicionarServicoAgendamento(item);
      return;
    }

    if (this.novoAgendamento) {
      this.servicosNovoAgendamento.push(item);
      this.atualizarHoraFimNovoAgendamento();
    }
  }

  abrirDialogProfissionalDetalheAgenda(profissionalId?: number, nomeProfissional?: string) {
    if (!profissionalId || !nomeProfissional) {
      return;
    }
    this.profissionalSelecionado = {
      id: profissionalId,
      nomeProfissional: nomeProfissional
    };
    this.exibirDetalheAgendaProfissional = true;
  }

  abrirDetalheAgendamentoPorProfissional(agendamentoId: number) {
    this.abrirDialogDetalheAgendamento(agendamentoId);
  }

  removerItemExclusivo() {
    this.novoAgendamento.itemExclusivoId = undefined;
    this.descricaoItemExclusivoSelecionado = undefined;
  }


  // ACOES DE DETALHE / EDICAO
  acaoConfirmarAgendamento(confirmado: boolean) {
    if (confirmado) {
      this.carregarConfiguracoesDaAgenda();
    }
  }

  acaoExcluirAgendamento(excluido: boolean) {
    if (excluido) {
      this.exibirMensagemSucesso();
      this.carregarConfiguracoesDaAgenda();
    }
  }

  habilitarEdicaoDescricao() {
    this.descricaoOriginal = this.agendamentoSelecionado?.descricao ?? '';
    this.modoEdicaoDescricao = true;
  }

  cancelarEdicaoDescricao() {
    if (!this.agendamentoSelecionado) {
      return;
    }
    this.agendamentoSelecionado.descricao = this.descricaoOriginal;
    this.modoEdicaoDescricao = false;
  }

  salvarDescricao() {
    if (!this.agendamentoSelecionado) {
      return;
    }

    this.agendaEmpresaService.atualizarDescricao(
      this.agendamentoSelecionado.id,
      this.agendamentoSelecionado.descricao ?? ''
    ).subscribe({
      next: () => {
        this.exibirMensagemSucessoDialog();
        this.modoEdicaoDescricao = false;
      },
      error: (err: any) => {
        this.exibirMensagemErroDialog(err);

      }
    })

  }

  alterarPreferencia(preferencialAtual: boolean) {
    if (!this.agendamentoSelecionado) {
      return;
    }

    const preferenciaAnterior = !preferencialAtual;

    this.agendaEmpresaService.alterarPreferencia(
      this.agendamentoSelecionado.id,
      preferencialAtual
    ).subscribe({
      next: () => {
        this.exibirMensagemSucessoDialog();
        this.carregarAgendamento();
        this.carregarConfiguracoesDaAgenda();
      },
      error: (err: any) => {
        this.agendamentoSelecionado!.preferencial = preferenciaAnterior;
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  abrirDetalheAgendamento(id: number): void {
    this.agendamentoSelecionado = undefined;
    this.modoEdicaoDescricao = false;
    this.exibirDetalheAgendamento = true;
  }

  fecharDetalheAgendamento(): void {
    this.exibirDetalheAgendamento = false;
  }

  abrirDetalheBloqueio(bloqueioId: number): void {
    this.bloqueioIdSelecionado = bloqueioId;
    this.exibirDetalheBloqueio = true;
  }

  abrirSelecaoCliente(): void {
    this.exibirSelecaoCliente = true;
  }

  abrirDialogCadastroCliente() {
    this.exibirCadastroCliente = true;
  }

  abrirDialogSelecaoServico() {
    this.exibirSelecaoServico = true;
  }

  verificarRecarregarReagendamento(data: string) {
    const dataCalendario = DateUtil.formatarDataIsoLocal(this.dataSelecionadaCalendario);

    if (dataCalendario === data) {
      this.carregarConfiguracoesDaAgenda();
    }

  }

  // UTILITARIOS

  private toLocalDate(date: Date): string {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  private toLocalTime(date: Date): string {
    return date.toTimeString().substring(0, 5);
  }

  private montarDtoAtualizarAgendamento(evento: EventApi) {
    const resourceId = evento.getResources()[0].id;
    return {
      dataAgendamento: this.toLocalDate(evento.start!),
      horaInicio: this.toLocalTime(evento.start!),
      horaFim: this.toLocalTime(evento.end!),
      profissionalId: resourceId
    };
  }

  private montarDtoAtualizarBloqueio(evento: EventApi): BloqueioAgendaUpdateRequest {
    return {
      horaInicio: this.toLocalTime(evento.start!),
      horaFim: this.toLocalTime(evento.end!)
    };
  }

  private getCalendarApi() {
    return this.calendarComponent.getApi();
  }

  private navegarCalendario(acao: 'prev' | 'next' | 'today') {
    const api = this.getCalendarApi();
    api[acao]();
    this.carregarConfiguracoesDaAgenda();
  }

  private atualizarHoraFimNovoAgendamento() {
    if (!this.novoAgendamento) {
      return;
    }
    this.novoAgendamento.horaFim = calcularHoraFimAgendamento(
      this.novoAgendamento.horaInicio,
      this.servicosNovoAgendamento
    );
  }

  private montarDataHora(baseDate: Date, hora?: string): Date | null {
    if (!hora) {
      return null;
    }
    const [horaStr, minutoStr] = hora.substring(0, 5).split(':');
    const horas = Number(horaStr);
    const minutos = Number(minutoStr);

    if (Number.isNaN(horas) || Number.isNaN(minutos)) {
      return null;
    }

    const data = new Date(baseDate);
    data.setHours(horas, minutos, 0, 0);
    return data;
  }

  private verificarConflitoAntesDeSalvar(): boolean {
    const profissionalId = this.novoAgendamento.profissionalId;
    const dataAgendamento = this.novoAgendamento.dataAgendamento;

    if (!profissionalId || !dataAgendamento) {
      return false;
    }

    const inicioNovo = this.montarDataHora(dataAgendamento, this.novoAgendamento.horaInicio);
    const fimNovo = this.montarDataHora(dataAgendamento, this.novoAgendamento.horaFim);

    if (!inicioNovo || !fimNovo) {
      return false;
    }

    const eventos = this.getCalendarApi().getEvents();

    return eventos.some(evento => {
      const profissionalNoEvento = Number(evento.extendedProps['profissionalId'] ?? 0);
      if (profissionalNoEvento !== profissionalId) {
        return false;
      }

      if (!evento.start || !evento.end) {
        return false;
      }

      return this.existeConflitoIntervalo(inicioNovo, fimNovo, evento.start, evento.end);
    });
  }

  private existeConflitoIntervalo(inicioA: Date, fimA: Date, inicioB: Date, fimB: Date): boolean {
    return inicioA < fimB && fimA > inicioB;
  }

  rolarTelaDialog() {
    setTimeout(() => {
      const content = this.dialog?.container?.querySelector('.p-dialog-content');
      if (content) {
        content.scrollTop = 0;
      }
    });
  }

}
